var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 201,
    viewBox: "0 0 161 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_1922)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.650391,
    width: 160,
    height: 200,
    rx: 8,
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.444 179.65C25.652 179.65 26.884 178.53 26.884 176.69C26.884 175.282 25.988 174.29 24.164 174.082V173.97C25.796 173.778 26.5 172.834 26.5 171.57C26.5 169.874 25.268 168.93 23.22 168.93H17.22V179.65H23.444ZM18.932 170.482H23.028C24.228 170.482 24.788 170.946 24.788 171.954C24.788 172.962 24.18 173.426 22.98 173.426H18.932V170.482ZM18.932 174.85H23.252C24.516 174.85 25.156 175.33 25.156 176.45C25.156 177.618 24.532 178.098 23.252 178.098H18.932V174.85ZM29.7311 170.77V168.93H28.0031V170.77H29.7311ZM29.7311 179.65V171.698H28.0031V179.65H29.7311ZM33.0593 179.65V168.93H31.3313V179.65H33.0593ZM36.3874 179.65V168.93H34.6594V179.65H36.3874ZM41.7475 179.81C43.9875 179.81 45.4595 178.93 45.4595 177.442C45.4595 176.13 44.5955 175.49 42.7075 175.25L40.8675 174.994C39.6675 174.834 39.3475 174.61 39.3475 173.986C39.3475 173.234 39.8595 172.914 41.3155 172.914C43.0755 172.914 43.5555 173.41 43.5555 174.354V174.45H45.2675V174.402C45.2675 172.514 43.7955 171.538 41.3635 171.538C38.9155 171.538 37.6515 172.53 37.6515 173.922C37.6515 175.25 38.5635 175.89 40.0675 176.082L42.2435 176.37C43.3795 176.53 43.7635 176.738 43.7635 177.394C43.7635 178.098 43.2995 178.418 41.7475 178.418C40.0835 178.418 39.4595 178.082 39.4595 177.042V176.914H37.7315V176.962C37.7315 178.802 39.1875 179.81 41.7475 179.81ZM51.1686 182.37V177.41H51.2326C51.5526 178.866 52.7046 179.81 54.4966 179.81C56.9766 179.81 58.3366 178.146 58.3366 175.682C58.3366 173.218 56.9446 171.538 54.4806 171.538C52.6086 171.538 51.4886 172.434 51.1686 173.906H51.0246V171.698H49.4406V182.37H51.1686ZM51.1686 175.81V175.666C51.1686 173.954 52.1606 173.122 53.9366 173.122C55.6006 173.122 56.6086 173.762 56.6086 175.682C56.6086 177.586 55.6166 178.242 53.9046 178.242C52.2086 178.242 51.1686 177.442 51.1686 175.81ZM61.8704 179.81C63.6784 179.81 64.9424 179.01 65.3584 177.666H65.4704V179.65H67.0544V174.818C67.0544 172.914 65.9184 171.538 63.3904 171.538C60.8624 171.538 59.3584 172.898 59.3584 174.706V174.77H61.0704V174.706C61.0704 173.538 61.7904 173.058 63.2624 173.058C64.7824 173.058 65.3584 173.522 65.3584 174.834V175.298L61.7424 175.682C60.1744 175.858 59.1824 176.498 59.1824 177.73C59.1824 179.042 60.2224 179.81 61.8704 179.81ZM60.9104 177.618C60.9104 176.994 61.3424 176.786 62.2384 176.674L65.3584 176.322C65.3584 177.89 64.1424 178.562 62.3344 178.562C61.3424 178.562 60.9104 178.258 60.9104 177.618ZM69.8769 182.37C71.5089 182.37 72.4049 181.938 73.0609 180.514L77.2049 171.698H75.3009L73.4289 175.906L72.6769 177.826H72.5489L71.7649 175.922L69.7329 171.698H67.7969L71.7169 179.65L71.5249 180.066C71.2849 180.61 70.9969 180.802 70.2929 180.802H68.7409V182.37H69.8769ZM79.778 179.65V175.714C79.778 173.954 80.37 173.09 82.082 173.09C83.618 173.09 84.226 173.762 84.226 175.33V179.65H85.938V175.714C85.938 173.954 86.546 173.09 88.242 173.09C89.778 173.09 90.402 173.762 90.402 175.33V179.65H92.114V174.866C92.114 172.946 91.074 171.538 89.01 171.538C86.994 171.538 86.098 172.802 85.89 174.162H85.794C85.57 172.642 84.594 171.538 82.786 171.538C80.802 171.538 79.938 172.77 79.73 174.098H79.634V171.698H78.05V179.65H79.778ZM97.6594 179.81C100.027 179.81 101.691 178.642 101.691 176.946V176.802H99.9634V176.93C99.9634 177.874 99.2754 178.418 97.6114 178.418C95.7714 178.418 95.0194 177.602 94.9554 176.066H101.707C101.755 175.826 101.771 175.602 101.771 175.314C101.771 172.898 100.091 171.538 97.6274 171.538C95.0354 171.538 93.3394 173.202 93.3394 175.682C93.3394 178.338 95.0514 179.81 97.6594 179.81ZM97.5954 172.898C99.2914 172.898 100.139 173.602 100.139 175.074V175.106H94.9714C95.0674 173.682 95.8354 172.898 97.5954 172.898ZM104.794 179.65V175.714C104.794 173.986 105.578 173.09 107.322 173.09C108.97 173.09 109.642 173.842 109.642 175.33V179.65H111.37V174.866C111.37 173.026 110.282 171.538 108.074 171.538C106.058 171.538 105.002 172.818 104.762 174.162H104.65V171.698H103.066V179.65H104.794ZM118.125 179.65V178.098H116.685C115.693 178.098 115.245 177.842 115.245 176.866V173.138H118.125V171.698H115.245V169.954H113.533V171.698H112.189V173.138H113.533V176.962C113.533 178.898 114.589 179.65 116.301 179.65H118.125Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 28.8237,
    y1: 131.118,
    x2: 28.8237,
    y2: -10.3968,
    stroke: "url(#paint0_linear_51_1922)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.8237,
    y1: 131.118,
    x2: 64.8237,
    y2: -10.3968,
    stroke: "url(#paint1_linear_51_1922)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.824,
    y1: 131.118,
    x2: 100.824,
    y2: -10.3968,
    stroke: "url(#paint2_linear_51_1922)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.824,
    y1: 131.118,
    x2: 135.824,
    y2: -10.3968,
    stroke: "url(#paint3_linear_51_1922)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 29.9792,
    x2: 198.245,
    y2: 29.9792,
    stroke: "url(#paint4_linear_51_1922)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 88.9792,
    x2: 198.245,
    y2: 88.9792,
    stroke: "url(#paint5_linear_51_1922)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 58.9792,
    x2: 198.245,
    y2: 58.9792,
    stroke: "url(#paint6_linear_51_1922)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17.1504,
    width: 71,
    height: 71,
    rx: 35.5,
    fill: "url(#paint7_linear_51_1922)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_51_1922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.455 44.6306C49.5122 44.6306 48.6079 45.0052 47.9412 45.6719C47.2745 46.3386 46.8999 47.2429 46.8999 48.1858C46.8999 49.1286 47.2745 50.0329 47.9412 50.6996C48.6079 51.3663 49.5122 51.7409 50.455 51.7409C51.3979 51.7409 52.3022 51.3663 52.9689 50.6996C53.6356 50.0329 54.0102 49.1286 54.0102 48.1858C54.0102 47.2429 53.6356 46.3386 52.9689 45.6719C52.3022 45.0052 51.3979 44.6306 50.455 44.6306Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8645 40.4829C33.8645 38.8459 35.1918 37.5203 36.8271 37.5203H64.0832C65.7186 37.5203 67.0458 38.8475 67.0458 40.4829V55.8885C67.0458 57.5255 65.7186 58.8511 64.0832 58.8511H36.8271C36.4381 58.8511 36.0528 58.7745 35.6934 58.6256C35.3339 58.4767 35.0073 58.2585 34.7322 57.9834C34.4571 57.7083 34.2389 57.3817 34.09 57.0223C33.9411 56.6628 33.8645 56.2776 33.8645 55.8885V40.4829ZM44.5299 48.1857C44.5299 46.6142 45.1542 45.1071 46.2654 43.9959C47.3766 42.8847 48.8837 42.2605 50.4552 42.2605C52.0266 42.2605 53.5337 42.8847 54.6449 43.9959C55.7561 45.1071 56.3804 46.6142 56.3804 48.1857C56.3804 49.7572 55.7561 51.2643 54.6449 52.3755C53.5337 53.4867 52.0266 54.1109 50.4552 54.1109C48.8837 54.1109 47.3766 53.4867 46.2654 52.3755C45.1542 51.2643 44.5299 49.7572 44.5299 48.1857ZM61.1206 47.0006C60.8063 47.0006 60.5049 47.1255 60.2826 47.3477C60.0604 47.57 59.9356 47.8714 59.9356 48.1857V48.1983C59.9356 48.8525 60.4665 49.3834 61.1206 49.3834H61.1332C61.4475 49.3834 61.749 49.2585 61.9712 49.0363C62.1934 48.8141 62.3183 48.5126 62.3183 48.1983V48.1857C62.3183 47.8714 62.1934 47.57 61.9712 47.3477C61.749 47.1255 61.4475 47.0006 61.1332 47.0006H61.1206ZM38.6047 48.1857C38.6047 47.8714 38.7295 47.57 38.9518 47.3477C39.174 47.1255 39.4754 47.0006 39.7897 47.0006H39.8024C40.1167 47.0006 40.4181 47.1255 40.6403 47.3477C40.8626 47.57 40.9874 47.8714 40.9874 48.1857V48.1983C40.9874 48.5126 40.8626 48.8141 40.6403 49.0363C40.4181 49.2585 40.1167 49.3834 39.8024 49.3834H39.7897C39.4754 49.3834 39.174 49.2585 38.9518 49.0363C38.7295 48.8141 38.6047 48.5126 38.6047 48.1983V48.1857Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_51_1922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0106 53.1446C63.7401 52.9939 63.427 52.9381 63.1211 52.986C62.8152 53.0339 62.5341 53.1828 62.3227 53.409L62.3222 53.4095L54.9994 61.2554C54.9993 61.2555 54.9992 61.2556 54.9991 61.2557C54.8148 61.4531 54.6921 61.7 54.6462 61.9662C54.6002 62.2325 54.6331 62.5064 54.7407 62.7542L55.5328 62.4103L54.7407 62.7542C54.8484 63.0021 55.0261 63.2131 55.252 63.3613C55.4779 63.5096 55.7423 63.5885 56.0125 63.5885H56.0126H59.9509L58.8597 67.5888C58.8596 67.5892 58.8595 67.5896 58.8594 67.5899L63.8179 54.1529L64.6136 53.8176C64.4934 53.5322 64.2811 53.2953 64.0106 53.1446ZM64.0106 53.1446L63.5903 53.8989L64.0102 53.1444C64.0103 53.1445 64.0105 53.1446 64.0106 53.1446ZM64.6737 54.7204L64.6739 54.7196L59.6923 67.8178C59.6612 67.9306 59.6689 68.0506 59.7141 68.1585C59.7594 68.2665 59.8395 68.3562 59.9417 68.4132C60.0439 68.4702 60.1622 68.4914 60.2778 68.4732C60.3935 68.455 60.4996 68.3986 60.5794 68.3129L61.2107 68.9021L61.211 68.9017C61.2111 68.9016 61.2112 68.9015 61.2113 68.9014L68.5335 61.0562C68.5336 61.0561 68.5337 61.056 68.5338 61.0559C68.7181 60.8585 68.8408 60.6116 68.8867 60.3454C68.9326 60.0791 68.8998 59.8052 68.7921 59.5574C68.6845 59.3095 68.5068 59.0985 68.2809 58.9503C68.0549 58.802 67.7906 58.7231 67.5204 58.7231H67.5203H63.5819L64.6737 54.7204Z",
    fill: "#C1D6FF",
    stroke: "#F5F8FF",
    strokeWidth: 1.727
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17.1504,
    width: 71,
    height: 71,
    rx: 35.5,
    stroke: "url(#paint8_linear_51_1922)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_1922",
    x1: 29.3237,
    y1: 9.68107,
    x2: 29.3238,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_1922",
    x1: 65.3237,
    y1: 9.68107,
    x2: 65.3238,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_1922",
    x1: 101.324,
    y1: 9.68107,
    x2: 101.324,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_51_1922",
    x1: 136.324,
    y1: 9.68107,
    x2: 136.324,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_51_1922",
    x1: -60.1421,
    y1: 30.4792,
    x2: 195.012,
    y2: 30.4792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_51_1922",
    x1: -60.1421,
    y1: 89.4792,
    x2: 195.012,
    y2: 89.4792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_51_1922",
    x1: -60.1421,
    y1: 59.4792,
    x2: 195.012,
    y2: 59.4792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_51_1922",
    x1: 52.5,
    y1: 16.6504,
    x2: 52.5,
    y2: 88.6504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_51_1922",
    x1: 52.5,
    y1: 16.6504,
    x2: 52.5,
    y2: 88.6504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_1922"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.650391,
    width: 160,
    height: 200,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_51_1922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(31 32)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_51_1922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.7386,
    height: 16.7386,
    fill: "white",
    transform: "translate(53.3972 51.741)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact7);
export default __webpack_public_path__ + "static/media/contact7.616d618fbb67a0b1d0975f2db93788d0.svg";
export { ForwardRef as ReactComponent };